import { Ellipsis } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const MoreIcon = createLucideIcon(Ellipsis);
